module.exports = __webpack_public_path__ + "img/pegah.8869a87.png";